import settings from "../../assets/settings.svg";
import logout from "../../assets/logout.svg";
import x from "../../assets/x.svg";
import { createSignal } from "solid-js";
import Settings from "./Settings";
import { clearUserStore, userAnswers } from "../../stores/userStore";
import { useNavigate } from "@solidjs/router";

export default function User() {
  const nav = useNavigate();

  const [showSettings, setShowSettings] = createSignal(false);

  const logoutFun = () => {
    clearUserStore();
    history.replaceState(null, "", "/");
    nav("/");
  };

  return (
    <div class="npnm">
      <div class="row">
        <button
          style="background: transparent; padding-bottom: 5px;"
          onClick={() => setShowSettings(true)}>
          <div class="row">
            <img class="icon" style="padding-right: 5px;" src={settings}></img>
            <p class="icon-text">Settings</p>
          </div>
        </button>
      </div>
      <div class="row">
        <button style="background: transparent;" onClick={() => logoutFun()}>
          <div class="row">
            <img class="icon" style="padding-right: 5px;" src={logout}></img>
            <p class="icon-text">Log out</p>
          </div>
        </button>
      </div>
      {showSettings() && (
        <div class="settings-modal-overlay">
          <div class="settings-modal">
            <button class="x-button" onClick={() => setShowSettings(false)}>
              <img src={x} alt="Close" />
            </button>
            <Settings />
          </div>
        </div>
      )}
    </div>
  );
}
